<div class="webhooks-container settings-page">

  <div class="settings-page__content">
    <p class="settings-page__description">
      {{ 'SETTINGS_WEBHOOKS.DESCRIPTION' | translate }}
    </p>
    <p-tabs [value]="activeTab()" (valueChange)="onTabChange('' + $event)">
      <p-tablist>
        <p-tab value="webhooks">
          {{ 'SETTINGS_WEBHOOKS.TABS.WEBHOOKS' | translate }}
        </p-tab>
        <p-tab value="failures">
          {{ 'SETTINGS_WEBHOOKS.TABS.FAILURES' | translate }}
        </p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="webhooks">
          <tf-settings-webhooks-list />
        </p-tabpanel>
        <p-tabpanel value="failures">
          <tf-settings-webhook-failures />
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
